import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "usergroup",
  "use": "usergroup-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"usergroup\"><path d=\"M7.5 13A4.5 4.5 0 1 1 12 8.5 4.505 4.505 0 0 1 7.5 13zm7.5 7a5.006 5.006 0 0 0-5-5H5a5.006 5.006 0 0 0-5 5v4h15zm2.5-11A4.5 4.5 0 1 1 22 4.5 4.505 4.505 0 0 1 17.5 9zm1.5 2h-5a4.793 4.793 0 0 0-.524.053 6.514 6.514 0 0 1-1.576 2.216A7.008 7.008 0 0 1 17 20h7v-4a5.006 5.006 0 0 0-5-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/usergroup.svg
// module id = KXge
// module chunks = 1